import { useState, useCallback } from 'react'

export const useMapTypeControl = (initialType = 'roadmap') => {
  const [mapTypeId, setMapTypeId] = useState(initialType)

  const handleMapTypeChange = useCallback((_, newMapTypeId) => {
    if (newMapTypeId !== null) setMapTypeId(newMapTypeId)
  }, [])

  return { mapTypeId, handleMapTypeChange }
}
